{
  "es": {
    "form": {
      "actions": {
        "cancel": "Cancelar",
        "clear": "Limpiar",
        "closeFullPage": "Cerrar página completa",
        "copyText": "Haz clic para copiar el texto",
        "create_and_send_to_customer": "Crear y enviar al cliente",
        "create_and_share": "Crear y compartir con el cliente",
        "create_and_share_partners_only": "Crear y compartir con colaborador(es)",
        "create_and_share_with_partners": "Crear y compartir con el cliente y colaborador(es)",
        "next": "Siguiente",
        "only_create": "Solo crear",
        "openFullPage": "Abrir en página completa",
        "save": "Guardar",
        "saveChanges": "Guardar cambios",
        "search": "Buscar...",
        "send": "Enviar",
        "send_and_create_another": "Enviar y crear otro",
        "send_to_customer": "Enviar al cliente",
        "share_with_customer": "Compartir con el cliente",
        "submit": "Guardar",
        "submit_and_create_another": "Guardar y crear otro"
      },
      "back": "Paso anterior",
      "labels": {
        "columns": "Columnas",
        "from": "Desde",
        "no_results": "Sin resultados",
        "to": "Hasta"
      },
      "notifications": {
        "textHasBeenCopied": "El texto se ha copiado"
      },
      "password": "Contraseña",
      "shortcuts": {
        "save_mac": "⌘ + Intro para guardar",
        "save_windows": "Ctrl + Intro para guardar",
        "send_mac": "⌘ + Intro para enviar",
        "send_windows": "Ctrl + Intro para enviar"
      },
      "steps": "Paso {count} de {total}",
      "writeEmployeeNameReject": "Escribe <i><b>{employeeName}</b></i> para continuar."
    }
  }
}
